<template>
  <div>
    <nav-bar title="隐私协议"></nav-bar>
    <ih-panel
      v-for="(item, key) in panelList"
      @click.native="toRoute(item.text)"
      :sign="item.sign"
      :content="item.time"
      :text="item.text"
      :key="key"
    ></ih-panel>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import ihPanel from "@/components/ihPanel";

export default {
  name: "protocol",
  data() {
    return {
      panelList: [
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "注册协议",
          time: "2020/03/06 12:33",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "隐私协议",
          time: "2020/03/06 12:33",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "电子合同",
          time: "2020/03/06 12:33",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "设备使用协议",
          time: "2020/03/06 12:33",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "位置隐私协议",
          time: "2020/03/06 12:33",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "手机通知协议",
          time: "2020/03/06 12:33",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "平台服务协议",
          time: "2020/03/06 12:33",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "工作服务协议",
          time: "2020/03/06 12:33",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "交易服务协议",
          sign: "0"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "用工服务协议",
          sign: "0"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "工作规范管理协议",
          sign: "0"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "出车安全协议",
          sign: "0"
        }
      ]
    };
  },
  components: {
    NavBar,
    ihPanel
  },
  methods: {
    toRoute() {}
  }
};
</script>

<style scoped></style>
